"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureOrganizationRole = exports.OrganizationInvitationStatus = void 0;
const User_1 = require("./User");
var OrganizationInvitationStatus;
(function (OrganizationInvitationStatus) {
    OrganizationInvitationStatus["Pending"] = "Pending";
    OrganizationInvitationStatus["Rejected"] = "Rejected";
    OrganizationInvitationStatus["Accepted"] = "Accepted";
    OrganizationInvitationStatus["Viewed"] = "Viewed";
})(OrganizationInvitationStatus = exports.OrganizationInvitationStatus || (exports.OrganizationInvitationStatus = {}));
const ensureOrganizationRole = (role) => {
    if (role !== User_1.Role.OrganizationAdmin &&
        role !== User_1.Role.OrganizationDeviceManager &&
        role !== User_1.Role.OrganizationUser) {
        throw new Error('Not an organization role');
    }
};
exports.ensureOrganizationRole = ensureOrganizationRole;
//# sourceMappingURL=OrganizationInvitation.js.map